import {DTemplate} from './DTemplate.js';
import {Chat} from './Chat.js';
import {ChatSlider} from './ChatSlider.js';
import {HeightResize} from './HeightResize.js';
import {ReloadPopup} from './ReloadPopup.js';
import {Public} from './Public.js';

export class PlayerChat {
	constructor(el) {
		if (!el) {
			return;
		}
		this.parent = el;
		[this.el, this.$] = DTemplate(`PlayerChat`);
		let key = el.getAttribute(`stream-key`);

		let config = el.getAttribute(`data-config`);
		if (config) {
			this.config = window[config];
		} else {
			this.config = new PlayerChatConfig();
		}
		console.log(`PlayerChat.js : PlayerChat.config = `, this.config);

		this.$.waiting_message.innerText = this.config.waiting;

		let display = el.getAttribute(`data-display-id`);
		if (display) {
			display = document.getElementById(display);
			if (display) {
				while (display.firstChild) {
					this.$.display.appendChild(display.firstChild);
				}
				display.remove();
			} else {
				this.$.display.remove();
			}
		} else {
			this.$.display.remove();
		}

		el.appendChild(this.el);
		HeightResize.init();

		// CMJ TODO: this is a little tricky, since here I am forcing us to 
		// use a vchat combination, since we define this in PlayerChat.html
		// What I should really do here, is allow a 'disable' option,
		// and then select vchat or jitsi chat based on the option.
		// Let's think this through further...
		if (this.config.config.chat) {
			console.log(`this.config.chat = ${this.config.config.chat}`);
			if (this.isVchat()) {
				console.log(`Using vchat`);
				this.$.chat.remove();
				console.log(`creating ChatSlider`);
				new ChatSlider(this.$.slider, this.$);
				this.$.vchat.setAttribute(`room`, this.getVchatRoom());
			} else {
				console.log(`Using prosody chat`);
				this.$.vchat.remove();
				if (this.config.AmbiguousProperty(`chat`)) {
					console.log(`PlayerChat: Configuring chat and ChatSlider`);
					new Chat(this.$.chat, this.$);
					new ChatSlider(this.$.slider, this.$);
				} else {
					this.$.chat.style.display = `none`;
					this.$.slider.style.display = `none`;
				}
			}
		} else {
			// console.log(`Removing chat entirely.`);
			this.$.chat.remove();
			this.$.vchat.remove();
			this.$.slider.remove();
		}
		if (!this.config.AmbiguousProperty(`login`)) {
			new ReloadPopup({});			
		}
		const lib = document.createElement(`script`);
		lib.setAttribute(`id`, `veedo-lib-script`);
		lib.setAttribute(`data-stream-key`, key);
		lib.setAttribute(`data-div-id`,`veedo-player`);
		lib.addEventListener(`load`, (evt)=>{
			// since we're loading veedolib async, we have
			// to init it separately
			if (globalThis.VeedoLib) {
				new globalThis.VeedoLib();
			} else {
				new window.VeedoLib();
			}
			// console.log(`veedolib loaded`);
		});
		lib.setAttribute(`src`, Public.Prefix + `js/veedolib.js`);
		document.body.appendChild(lib);
	}
	isVchat() {
		return this.parent.hasAttribute(`data-vchat`) && ``!=this.parent.getAttribute(`data-vchat`);
	}
	getVchatRoom() {
		return this.parent.getAttribute(`data-vchat`);
	}
}